import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzIconModule} from 'ng-zorro-antd/icon';

import {DiActionMenuComponent} from 'app/common/di-action-menu/di-action-menu.component';
import {NzDropdownModule} from 'ng-zorro-antd/dropdown';

@NgModule({
    declarations: [DiActionMenuComponent],
    imports: [CommonModule, TranslateModule, NzIconModule, NzButtonModule, NzDropdownModule],
    exports: [DiActionMenuComponent],
    providers: []
})
export class DiActionMenuModule {}
